import { render } from "./LoaderLabel.vue?vue&type=template&id=70539770&scoped=true&ts=true"
import script from "./LoaderLabel.vue?vue&type=script&lang=ts"
export * from "./LoaderLabel.vue?vue&type=script&lang=ts"

import "./LoaderLabel.vue?vue&type=style&index=0&id=70539770&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70539770"]])

export default __exports__